import React, { useEffect, useState } from 'react';
import { Container, Grid, Paper, Typography, Button, TextField, MenuItem, Select, FormControl, InputLabel, Tooltip } from '@mui/material';
import Navigation from '../components/Navbar';
import Footer from '../components/Footer';
import './Partnerwithus.css';
import heroImage from '../assets/images/Logo.png';

const professions = ["Student", "Home Maker", "Freelancer", "Small Business Owner", "Corporate Representative", "Other"];
const experienceLevels = ["Beginner (0-1 year)", "Intermediate (1-3 years)", "Advanced (3-5 years)", "Expert (5+ years)"];
const countries = ["United States", "Canada", "United Kingdom", "India", "Australia", "Other"];

const Partnerwithus = () => {
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        country: "",
        profession: "",
        experience: "",
        skills: "",
        portfolio: "",
        linkedin: "",
        instagram: "",
        twitter: "",
        additionalInfo: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Submitted Data:", formData);
    };

    return (
        <>
            <Navigation />
            <Container className="partner-container">
                <Typography variant="h3" className="page-header">
                    🌟 Unlock Limitless Opportunities with Us!
                </Typography>
                <Typography variant="body1" className="page-description">
                    The world is evolving fast, and the future belongs to those who collaborate, innovate, and grow together. Whether you're a creative freelancer, a passionate student, or a thriving business, we invite you to be part of something extraordinary.
                </Typography>
                <Typography variant="body1" className="page-description">
                    Join our diverse network of skilled professionals and businesses that are shaping the digital future. Gain access to premium projects, meaningful collaborations, and revenue-sharing opportunities—all within an ecosystem designed to help you excel.
                </Typography>
                <Typography variant="body1" className="page-description">
                    If you have the expertise, the vision, and the drive to make an impact, we want you on board! 🚀 Take the first step towards an exciting journey—apply now and let's build the future together.
                </Typography>

                {/* Application Form */}
                <Paper className="application-form">
                    <Typography variant="h5" className="form-title">🌟 Apply Now & Join Our Network</Typography>
                    <form className="partner-form" onSubmit={handleSubmit}>
                        <Tooltip title="Enter your full legal name">
                            <TextField label="Full Name" name="fullName" variant="outlined" fullWidth margin="normal" required onChange={handleChange} InputLabelProps={{ shrink: false }} placeholder="Full Name" />
                        </Tooltip>
                        <Tooltip title="Enter a valid email address">
                            <TextField label="Email Address" name="email" type="email" variant="outlined" fullWidth margin="normal" required onChange={handleChange} InputLabelProps={{ shrink: false }} placeholder="Email Address" />
                        </Tooltip>
                        <Tooltip title="Provide a reachable contact number">
                            <TextField label="Phone Number" name="phone" type="tel" variant="outlined" fullWidth margin="normal" required onChange={handleChange} InputLabelProps={{ shrink: false }} placeholder="Phone Number" />
                        </Tooltip>
                        
                        <FormControl fullWidth margin="normal" required>
                            <InputLabel shrink={false}>Country</InputLabel>
                            <Select name="country" value={formData.country} onChange={handleChange} displayEmpty>
                                <MenuItem value="" disabled></MenuItem>
                                {countries.map((country) => (
                                    <MenuItem key={country} value={country}>{country}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl fullWidth margin="normal" required>
                            <InputLabel shrink={false}>Profession</InputLabel>
                            <Select name="profession" value={formData.profession} onChange={handleChange} displayEmpty>
                                <MenuItem value="" disabled></MenuItem>
                                {professions.map((prof) => (
                                    <MenuItem key={prof} value={prof}>{prof}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        
                        <FormControl fullWidth margin="normal" required>
                            <InputLabel shrink={false}>Experience Level</InputLabel>
                            <Select name="experience" value={formData.experience} onChange={handleChange} displayEmpty>
                                <MenuItem value="" disabled> </MenuItem>
                                {experienceLevels.map((level) => (
                                    <MenuItem key={level} value={level}>{level}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <Tooltip title="List your key skills separated by commas">
                            <TextField label="Skills & Expertise" name="skills" variant="outlined" fullWidth margin="normal" required onChange={handleChange} InputLabelProps={{ shrink: false }} placeholder="Skills & Expertise" />
                        </Tooltip>
                        <Tooltip title="Provide a link to your portfolio or personal website">
                            <TextField label="Portfolio/Website" name="portfolio" variant="outlined" fullWidth margin="normal" onChange={handleChange} InputLabelProps={{ shrink: false }} placeholder="Portfolio/Website" />
                        </Tooltip>

                        <Button variant="contained" color="primary" type="submit" className="submit-button">
                            🚀 Submit Application
                        </Button>
                    </form>
                </Paper>
            </Container>
            <Footer />
        </>
    );
};

export default Partnerwithus;